import React from "react";

import {
  Card,
  CardContainer,
  Container,
  NameInfo,
  TextBottom,
} from "./cardInfo.style";

const CardInfo = ({
  width,
  height,
  onClick,
  src,
  name,
  cursor,
  nameImage,
  titleImage,
  link,
}) => {
  const splitText = (text) => {
    const newText = text.split("Institute of ");
    return newText[1];
  };

  return (
    <CardContainer onClick={onClick} cursor={cursor}>
      {link ? (
        <a href={link} target="_blank" rel="noreferrer">
          <div style={{ width: "100%" }}>
            <Container>
              <Card>
                <div
                  className="card-cover"
                  style={{
                    backgroundImage: `url(${src})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    borderRadius: "20px",
                  }}
                >
                  <TextBottom>
                    {/* {titleImage && titleImage} <br /> */}
                    {nameImage && nameImage !== "DIGITECH"
                      ? splitText(nameImage)
                      : nameImage}
                  </TextBottom>
                </div>
              </Card>
            </Container>

            <NameInfo>{name}</NameInfo>
          </div>
        </a>
      ) : (
        <div style={{ width: "100%" }}>
          <Container>
            <Card>
              <div
                className="card-cover"
                style={{
                  backgroundImage: `url(${src})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "contain",
                  borderRadius: "20px",
                }}
              >
                <TextBottom>
                  {/* {titleImage && titleImage} <br /> */}
                  {nameImage && nameImage !== "DIGITECH"
                    ? splitText(nameImage)
                    : nameImage}
                </TextBottom>
              </div>
            </Card>
          </Container>

          <NameInfo>{name}</NameInfo>
        </div>
      )}
    </CardContainer>
  );
};

export default CardInfo;
